import styled from "styled-components";

export const StudentRegistrationDiv = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #0d039c;
  min-height: 100vh;

  .main-content {
    text-align: start;
    button {
      background: #e61f01;
      border: none;
    }
  }
`;
